import { TonOnChainTradeStruct } from '../../../common/on-chain-trade/ton-on-chain-trade/models/ton-on-chian-trade-types';

export interface DedustOnChainTradeStruct extends TonOnChainTradeStruct {}
